// extracted by mini-css-extract-plugin
module.exports = {"container":"ChimpMerch_container__66JF8","header":"ChimpMerch_header__18nPh","items":"ChimpMerch_items__1E_lg","item":"ChimpMerch_item__29eFi","button":"ChimpMerch_button__9vv4d"};